// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"716508b2","665":"49c6d149","736":"f120a793","902":"4f6be544"}[chunkId] + ".chunk.js";
};